<template>
  <form @submit.prevent="handleSubmit">
    <h2>Welcome to SignUp!</h2>
    <input type="text" required v-model="displayName" placeholder="Display Name">
    <input type="email" required v-model="email" placeholder="Email">
    <input type="password" required v-model="password" placeholder="Password">
    <div class="error">{{ error }}</div>
    <button v-if="!isPending">Sign Up</button>
    <div v-else class="spinners">
      <loading />
    </div>
  </form>
</template>

<script>

import useSignUp from "@/composable/useSignUp";
import { ref } from 'vue'
import { useRouter } from "vue-router";
import loading from "@/components/loading.vue";

export default {
  components: {
    loading,
  },
  setup(){
    const { signup, error, isPending } = useSignUp()
    const router = useRouter()

    const password = ref('')
    const email = ref('')
    const displayName = ref('')

    const handleSubmit = async () => {
      await signup(email.value, password.value, displayName.value)
      if(!error.value){
        console.log('Foydalanuvchi Muoffaqqiyatli Qo\'shilib bo\'ldi')
        router.push('/')
      }
    }

    return {
      password,
      email,
      error,
      handleSubmit,
      isPending,
      displayName
    }
  }
}

</script>

<style>

</style>